import React, { useEffect, useState } from "react";
import { UseCaseeventListApi } from "../../../api/api";
import { useSelector } from "react-redux";

export default function Step1NameEventType({ formData, setFormData }) {
  const [useCase, setUseCase] = useState([]);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    const fetchUseCase = async () => {
      try {
        const data = await UseCaseeventListApi("", user_id, organization_id);
        if (data?.data?.status) {
          setUseCase(data.data.data);
        }
      } catch (error) {
        console.error("Error fetching use cases:", error);
      }
    };

    fetchUseCase();
  }, []);

  return (
    <>
      <h4>Name and Event Type</h4>
      <p className="formTitle mt-3 mb-4">
        Provide a clear name and select the type of event you want to create.
      </p>

      <div className="row">
        {/* Event Name */}
        <div className="col-mg-6 col-lg-5">
          <label className="mb-2">Name</label>
          <input
            className="form-control"
            placeholder="Chef Cap Detection"
            type="text"
            value={formData.event_name || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                event_name: e.target.value,
              }))
            }
          />
        </div>

        {/* Event Type */}
        <div className="col-mg-6 col-lg-5">
          <label className="mb-2">Event Type</label>
          <select
            className="form-select"
            value={formData.event_type_id || ""}
            onChange={(e) => {
              const selectedIndex = e.target.selectedIndex;
              const selectedName = e.target.options[selectedIndex].text;

              setFormData((prev) => ({
                ...prev,
                event_type_id: e.target.value,
                usecase_name: selectedName,
              }));
            }}
          >
            <option value="">Select</option>
            {useCase.map((ele) => (
              <option key={ele._id} value={ele._id}>
                {ele.usecase_name}
              </option>
            ))}
          </select>
        </div>

        {formData.event_type_id === "68906edea673f16e978691f9" && (
          <>
            <div className="col-mg-6 col-lg-5">
              <label className="mb-2">Max people</label>
              <input
                className="form-control"
                placeholder="Enter max people"
                type="number"
                value={formData.event_data?.max_people || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    event_data: {
                      ...prev.event_data,
                      max_people: e.target.value,
                    },
                  }))
                }
              />
            </div>
            <div className="col-mg-6 col-lg-5">
              <label className="mb-2">Minimum Distance</label>
              <input
                className="form-control"
                placeholder="Enter minimum distance"
                type="number"
                value={formData.event_data?.min_distance || ""}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    event_data: {
                      ...prev.event_data,
                      min_distance: e.target.value,
                    },
                  }))
                }
              />
            </div>
          </>
        )}
      </div>
    </>
  );
}
